import {
  convertDecimalQuota,
  isStatoCavalloRetired,
  isWinner,
  retrieveImageGiubbaFromTipoIppica,
  retrieveSiglaMantello,
  retrieveStatoCavalloLabel,
} from 'features/ippica/functions';
import {
  selectBlockIppicaScommessa,
  selectIppicaRaceDetail,
  selectKeyListQuotaFissa,
  selectQuotaIppica,
} from 'features/ippica/selectors';

import { BlockScommessa } from 'features/ippica/settings/settings-types';
import { DynamicImage } from 'components/Image';
import { WinnerChip } from 'components/winnerChip';
import { isNotEmpty } from 'utility/functions';
import styles from './IppicaScommesseTableMainInfo.module.scss';
import { useGetCavallo } from 'features/ippica/hooks';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaScommesseTableMainInfoProps = {
  containerClassName?: string;
  indexCavallo?: number;
  keyCavallo: string;
  isOpen: boolean;
  isReverse?: boolean;
  isTestaATesta?: boolean;
};

export const IppicaScommesseTableMainInfo = ({
  keyCavallo,
  containerClassName,
  indexCavallo,
  isOpen,
  isReverse,
  isTestaATesta,
}: IppicaScommesseTableMainInfoProps) => {
  const { tipoIppica } = useTypedSelector(selectIppicaRaceDetail);
  const {
    fantino,
    nomeCavallo,
    ordineArrivo,
    codiceStatoCavallo,
    ultimePrestazioni,
    sesso,
    anni,
    codiceMantello,
    distanza,
  } = useGetCavallo(keyCavallo);

  const blockScommessa = useTypedSelector(selectBlockIppicaScommessa);
  const isTipoeScommessaAccoppiataTrio =
    blockScommessa === BlockScommessa.AccoppiataDisordine ||
    blockScommessa === BlockScommessa.AccoppiataOrdine ||
    blockScommessa === BlockScommessa.TrioDisordine ||
    blockScommessa === BlockScommessa.TrioOrdine;

  const quoteKeyListQuotaFissa = useTypedSelector(selectKeyListQuotaFissa(keyCavallo));
  const keyQuota = quoteKeyListQuotaFissa[0];
  const selectedQuota = useTypedSelector(selectQuotaIppica(keyCavallo, keyQuota));
  const quota = convertDecimalQuota(selectedQuota?.value);

  const urlGiubba = retrieveImageGiubbaFromTipoIppica(fantino?.giubbaImage?.src, tipoIppica);

  return (
    <div
      className={`${styles.container} ${containerClassName ? containerClassName : ''} ${
        isStatoCavalloRetired(codiceStatoCavallo) ? styles.retired : ''
      } ${isOpen ? styles.isOpenMoreInfo : ''} ${isReverse ? styles.reverse : ''}`}
    >
      {urlGiubba && isNotEmpty(urlGiubba) && (
        <span className={styles.imageContainer}>
          <DynamicImage
            src={urlGiubba}
            alt={fantino.nomeFantino ?? ''}
            title={fantino.nomeFantino}
            fill
            loading="lazy"
            decoding="async"
            className={styles.image}
          />
        </span>
      )}
      <div className={styles.textWrapper}>
        <div className={`${styles.horseInfoWrapper} ${isReverse ? styles.reverse : ''}`}>
          {nomeCavallo && (
            <span
              className={`${styles.horseName} ${isOpen ? styles.accent : ''} ${isReverse ? styles.reverse : ''} ${
                isTestaATesta ? styles.ellipsis : ''
              }`}
            >
              {nomeCavallo}
            </span>
          )}
          <ul className={styles.horseInfoList}>
            {ultimePrestazioni && <li className={styles.separator}>{ultimePrestazioni}</li>}
            {ultimePrestazioni && <li className={styles.separator}>-</li>}
            {sesso && <li className={styles.separator}>{sesso}</li>}
            {(codiceMantello || codiceMantello !== 0) && (
              <li className={styles.separator}>| {retrieveSiglaMantello(codiceMantello)}</li>
            )}
            {anni && <li className={styles.separator}>| {anni}</li>}
          </ul>
        </div>

        {/* info fantino */}
        {fantino?.nomeFantino && (
          <ul className={`${styles.riderInfoList} ${isReverse ? styles.reverse : ''}`}>
            <li
              className={`${styles.riderName} ${isTestaATesta ? styles.ellipsis : ''} ${
                isReverse ? styles.reverse : ''
              }`}
            >
              {fantino.nomeFantino}
            </li>
            {fantino.peso && <li className={styles.separator}>|</li>}
            {fantino.peso && <li className={styles.riderInfo}>{fantino.peso}kg</li>}
            {distanza !== 0 && <li className={styles.separator}>|</li>}
            {distanza !== 0 && <li className={styles.riderInfo}>{distanza} m.</li>}
          </ul>
        )}
        {isTipoeScommessaAccoppiataTrio && selectedQuota ? (
          <div className={styles.quotaVincente}> Vincente {quota}</div>
        ) : null}
      </div>

      {(isWinner(ordineArrivo) || isStatoCavalloRetired(codiceStatoCavallo)) && (
        <WinnerChip
          containerClassName={`${isStatoCavalloRetired(codiceStatoCavallo) ? styles.retired : ''}`}
          chipClassName={`${isStatoCavalloRetired(codiceStatoCavallo) ? styles.chipRetired : styles.winner}`}
          label={retrieveStatoCavalloLabel(codiceStatoCavallo)}
        />
      )}
    </div>
  );
};
